import React, {Component} from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';

import Language from '../../languages/spanish/';

class AdminSettings extends Component {
 constructor(props) {
  super(props);
  this.state = { }
 }

 render() {
  return (
   <div className="animated fadeIn">
    <Card>
     <CardHeader>

     </CardHeader>

     <CardBody>

     </CardBody>
    </Card>
   </div>
  );
 }

}

export default AdminSettings;



// WEBPACK FOOTER //
// ./src/views/Admin/Settings.js